import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, forwardRef } from 'react';
import classNames from 'classnames';
import isEmpty from 'lodash/fp/isEmpty';
import noop from 'lodash/fp/noop';
import useClickOutside from '../../hooks/useClickOutside';
const ToggleButton = (props) => {
    const { title, caret } = props;
    const toggleClassName = classNames('ModuleNavigation-dropdown', 'dropdown-toggle justify-content-between', {
        inactive: !caret,
    });
    return (_jsxs("a", Object.assign({ className: toggleClassName, role: 'button', id: 'basic-nav-dropdown' }, { children: [_jsx("span", { children: title }), caret && _jsx("span", { className: 'caret' })] })));
};
const DropdownMenu = (props) => {
    const { children } = props;
    if (isEmpty(children)) {
        return null;
    }
    return (_jsx("ul", Object.assign({ role: 'menu', className: 'dropdown-menu' }, { children: children })));
};
const AppMenuDropdownOpener = forwardRef((props, ref) => {
    const { open, children, onDropdownClick } = props;
    return (_jsx("li", Object.assign({ ref: ref, className: classNames('dropdown', { open }), onClick: onDropdownClick }, { children: children })));
});
export const AppMenuDropdown = (props) => {
    const { title, caret = false, onToggleAppMenu = noop, children } = props;
    const [isOpen, setIsOpen] = useState(false);
    const wrapperRef = useClickOutside(() => setIsOpen(false));
    const handleDropdownClick = () => {
        const newState = !isOpen;
        setIsOpen(newState);
        onToggleAppMenu(newState);
    };
    const openWithChildren = !isEmpty(children) && isOpen;
    return (_jsxs(AppMenuDropdownOpener, Object.assign({ open: openWithChildren, onDropdownClick: handleDropdownClick, ref: wrapperRef }, { children: [_jsx(ToggleButton, { title: title, caret: caret }), _jsx(DropdownMenu, { children: children })] })));
};
export default AppMenuDropdown;
